import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { Breadcrumbs } from 'foundations-components/transitional/components/Breadcrumbs';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Renders the breadcrumbs on MDX docs (a.k.a. human-authored docs) and endpoint
 * routes.
 */
export default function DocsBreadcrumbs({
  breadcrumbs
}) {
  if (!breadcrumbs) return null;
  return /*#__PURE__*/_jsx(Breadcrumbs, {
    flush: true,
    marginBlockStart: "200",
    marginBlockEnd: "400",
    children: breadcrumbs.map((breadcrumb, i) => breadcrumb.link ? /*#__PURE__*/_jsx(UIRouterLink, {
      to: breadcrumb.link,
      children: /*#__PURE__*/_jsx(Text, {
        typography: "body-100",
        as: "span",
        color: "text-interactive-default",
        children: breadcrumb.name
      })
    }, i) : /*#__PURE__*/_jsx(Text, {
      typography: "body-100",
      as: "span",
      color: "text-core-subtle",
      children: breadcrumb.name
    }, i))
  });
}